module.exports = __webpack_public_path__ + "img/Anhänger_Ru12t.d51dca6a.svg";